module.exports = __webpack_public_path__ + "Roboto-Regular.ttf?11eabca2251325cfc5589c9c6fb57b46";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Regular.ttf
// module id = 99
// module chunks = 0